import React, { Component } from "react";
import global from "../../global.css";
import classes from "./LawPage.css";
import Law from "../../assets/Law.png";

class LawPage extends Component {
  state = {
    RightNowPart: 1
  };

  render() {
    return (
      <div className={classes.Background}>
        <div className={global.Responsive} onWheel={this.onMouseWheel}>
          <div className={classes.partOne}>
            <img src={Law} alt="تصویر SIGN" className={classes.SignFirtOne} />
            <div>
              <h2>قرارداد بین شما و محراب سير کيش</h2>
              <p>
                با تشکر از شما برای انتخاب وب سایت محراب سیر کیش، لطفا قبل از استفاده
                از وب سایت، قوانین و شرایط استفاده از آن را به دقت مطالعه
                نمایید. با بازدید از این سایت، شما مشخص می کنید که شرایط این
                قرارداد را پذیرفته اید و به مفاد آن آگاه هستید. اگر با این شرایط
                و قوانین موافق نیستید لطفا به بازدید از سایت خاتمه دهید.
                <h3>استفاده از وب سایت</h3>
                از سرویس‌های ما سوء استفاده نکنید. بعنوان مثال از تداخل در
                سرویس‌های ما یا تلاش برای دسترسی به آنها با استفاده از روشی بجز
                رابط کاربری و دستورالعمل‌های ارایه شده توسط ما، خودداری کنید. در
                صورت عدم تبعیت شما از شرایط یا خط مشی‌های ما و یا در صورت مشکوک
                شدن به هرگونه سوء عملکرد، ما ممکن است ارایه سرویس‌ها به شما را
                متوقف کرده یا به حالت تعلیق در آوریم. اطلاعات این سایت برای
                استفاده شخصی شما می باشد، و شما نباید به هر شکلی آنرا نشر مجدد
                کنید. نشر مجدد اطلاعات با هر شکل و روشی اکیدا ممنوع است و فقط با
                عقد قرارداد با سپهر سیستم و مجوز کتبی از مالک اطلاعات (مالک این
                سایت) امکان پذیر است.
                <h3>تغییر در قوانین و مقررات</h3>
                  ما ممکن است این
                شرایط را تغییر دهیم تا بعنوان مثال تغییرات قانون یا تغییرات
                سرویس‌های ما را منعکس کنند. شما باید مرتبا شرایط را بررسی کنید.
                ما اعلامیه‌های مربوط به اصلاحات این قوانین را در این صفحه قرار
                خواهیم داد. تغییرات بصورت عطف‌به‌ماسبق اعمال نمی‌شوند. اگر شما
                با شرایط اصلاح شده برای یکی از سرویس‌ها موافق نباشید، باید
                استفاده خود از آن سرویس را متوقف کنید. اگر شما این شرایط را
                رعایت نکرده و ما بلافاصله اقدام نکنیم، به این معنا نیست که ما از
                حقوقی که ممکن است داشته باشیم (مانند اقداماتی در آینده) دست
                کشیده ایم.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LawPage;
